// No need for an enum helper
export enum RamCalculationErrorCode {
  SyntaxError = -1,
  ImportError = -2,
}
